interface AdCopyIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const AdCopyIcon = (props: AdCopyIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <g>
        <path
          style={{ fill: fillColor }}
          d="M23,19.2h6.7c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5H23c-0.3,0-0.5,0.2-0.5,0.5
            C22.5,19,22.7,19.2,23,19.2z M23,13.5h6.7c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5H23c-0.3,0-0.5,0.2-0.5,0.5
            C22.5,13.3,22.7,13.5,23,13.5z M23,16.3h6.7c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5H23c-0.3,0-0.5,0.2-0.5,0.5
            C22.5,16.1,22.7,16.3,23,16.3z M23,22.1h6.7c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5H23c-0.3,0-0.5,0.2-0.5,0.5
            C22.5,21.8,22.7,22.1,23,22.1z M13.5,27.8h16.2c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5H13.5c-0.3,0-0.5,0.2-0.5,0.5
            C13,27.6,13.2,27.8,13.5,27.8z M32,9.7h-21c-0.5,0-1,0.4-1,1v2.9H7.3c-0.5,0-1,0.4-1,1v13.3c0,1.6,1.3,2.9,2.9,2.9H32
            c0.5,0,1-0.4,1-1v-19C33,10.1,32.6,9.7,32,9.7z M32,29.7H9.2c-1.1,0-1.9-0.9-1.9-1.9V14.4h2.9v12.9c0,0.3,0.2,0.5,0.5,0.5
            c0.3,0,0.5-0.2,0.5-0.5V10.6h21V29.7z M13.5,24.9h16.2c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5H13.5c-0.3,0-0.5,0.2-0.5,0.5
            C13,24.7,13.2,24.9,13.5,24.9z M13.5,22.1h6.7c0.3,0,0.5-0.2,0.5-0.5V13c0-0.3-0.2-0.5-0.5-0.5h-6.7c-0.3,0-0.5,0.2-0.5,0.5v8.6
            C13,21.8,13.2,22.1,13.5,22.1z M14,13.5h5.7v7.6H14V13.5z"
        />
      </g>
    </svg>
  )
}

export default AdCopyIcon
